import { useRecoilValue } from 'recoil';
import { useHippoText } from '../../../hooks/useHippoText';
import WizardPagetemplate from '../../../templates/WizardPagetemplate';
import CoverableDetailsTemplate from '../../../templates/CoverableDetailsTemplate';
import { LinkBox, Message } from '@flos/react-ui';
import { getCoverableIndex } from '../../../utils/coverablesUtil';
import { getOnsaCurrentProductSelector } from '../../../recoil/selectors/getOnsaCurrentProductSelector';
import { allCoverablesOnsaAtom } from '../../../recoil/atoms/allCoverablesOnsaAtom';
import { useSetCarReplacement } from '../../../hooks/useSetCarReplacement';
import { carReplacementsAtom } from '../../../recoil/atoms/carReplacementsAtom';
import { useSaveCoverableInformation } from '../../../hooks/useSaveCoverableInformation';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';

const CarAlreadyInsuredStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { cars = [] } = coverables;
    const coverableIndex = getCoverableIndex(cars, currentProduct.fixedId);
    const coverableData = cars[coverableIndex];
    const replacementCars = useRecoilValue(carReplacementsAtom);
    const { setCarReplacement } = useSetCarReplacement();
    const { saveCoverableInformation } = useSaveCoverableInformation();

    return (
        <WizardPagetemplate onPrevious={goPrevious} onNext={goNext} hideNext={true}>
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-ALREADY-INSURED-CAR-HEADER')}
                subheader={getHippoText(
                    'DSS-COVERABLE-INFORMATION-STEP-ALREADY-INSURED-CAR-TEXT-INNER-HTML'
                )}
            >
                <div className="u-spacing-stack-m">
                    <LinkBox
                        className="flos-box u-spacing-stack-m"
                        title={getHippoText(
                            'DSS-COVERABLE-INFORMATION-STEP-ALREADY-INSURED-CAR-ANOTHER-CAR'
                        )}
                        onClick={() => {
                            const updatedCoverable: CoverableInformationToUpdateDTO = {
                                car: {
                                    publicId: coverableData.publicId,
                                    fixedId: coverableData.fixedId,
                                    hasActiveCarInsurance: true
                                },
                                productToUpdate: currentProduct.flavourName
                            };
                            void saveCoverableInformation(updatedCoverable).then(() => {
                                goNext();
                            });
                        }}
                    />
                    <>
                        {replacementCars?.map((car) => (
                            <LinkBox
                                key={car.fixedId}
                                className="flos-box u-spacing-stack-m"
                                title={`${getHippoText(
                                    'DSS-COVERABLE-INFORMATION-STEP-ALREADY-INSURED-CAR-CHANGE-OF-CAR'
                                )} ${car.make} ${car.model}`}
                                onClick={() => {
                                    void setCarReplacement(coverableData.fixedId, car.fixedId).then(
                                        () => {
                                            goNext();
                                        }
                                    );
                                }}
                            />
                        ))}
                    </>
                </div>
                <Message>
                    <h6 className="margin:0">
                        {getHippoText(
                            'DSS-COVERABLE-INFORMATION-STEP-ALREADY-INSURED-CAR-CHANGE-OF-CAR-HEADER'
                        )}
                    </h6>
                    <p>
                        {getHippoText(
                            'DSS-COVERABLE-INFORMATION-STEP-ALREADY-INSURED-CAR-CHANGE-OF-CAR-TEXT'
                        )}
                    </p>
                </Message>
            </CoverableDetailsTemplate>
        </WizardPagetemplate>
    );
};
export default CarAlreadyInsuredStep;
